export const skills = [
    {
        icon: "https://www.vectorlogo.zone/logos/android/android-icon.svg",
        title: "Android",
        tag: "skill"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        title: "Kotlin",
        tag: "skill"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        title: "Java",
        tag: "skill"
    },
    {
        icon: "https://developer.android.com/static/images/spot-icons/jetpack-compose.svg",
        title: "Compose",
        tag: "skill"
    },

    {
        icon: "https://cdn-icons-png.flaticon.com/512/174/174854.png",
        title: "HTML",
        tag: "skill"
    },
    {
        icon: "https://cdn-icons-png.flaticon.com/512/732/732190.png",
        title: "CSS",
        tag: "skill"
    },

    {
        icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png",
        title: "JavaScript",
        tag: "skill"
    },

    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
        title: "react",
        tag: "skill"
    },

    {
        icon: "https://cdn-icons-png.flaticon.com/512/760/760457.png",
        title: "React Native",
        tag: "skill"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
        title: "Spring",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/fluency/512/node-js.png",
        title: "Node.js",
        tag: "backend"
    },
    {
        icon: "https://img.icons8.com/color/512/express-js.png",
        title: "Express.js",
        tag: "backend"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        title: "MySQL",
        tag: "backend"
    },
    {
        icon: "https://www.svgrepo.com/show/303229/microsoft-sql-server-logo.svg",
        title: "MSSQL",
        tag: "backend"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg",
        title: "Postgres",
        tag: "backend"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        title: "MongoDB",
        tag: "backend"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg",
        title: "SQLite",
        tag: "backend"
    },

    {
        icon: "https://img.icons8.com/?size=512&id=33039&format=png",
        title: "AWS",
        tag: "backend"
    },

    {
        icon: "https://www.vectorlogo.zone/logos/google_play/google_play-icon.svg",
        title: "Play Store",
        tag: "platform"
    },

    {
        icon: "https://img.icons8.com/color/512/firebase.png",
        title: "Firebase",
        tag: "platform"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
        title: "AWS",
        tag: "platform"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg",
        title: "Azure",
        tag: "platform"
    },
    {
        icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        title: "Docker",
        tag: "platform"
    },

    {
        icon: "https://www.vectorlogo.zone/logos/jenkins/jenkins-icon.svg",
        title: "Jenkin",
        tag: "platform"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/bitbucket/bitbucket-icon.svg",
        title: "Bitbucket",
        tag: "platform"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
        title: "Git",
        tag: "platform"
    },

    {
        icon: "https://img.icons8.com/ios-glyphs/512/github.png",
        title: "Github",
        tag: "platform"
    },

    {
        icon: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
        title: "Figma",
        tag: "platform"
    },

    {
        icon: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/android-studio-icon.png",
        title: "A.Studio",
        tag: "platform"
    },

    {
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/IntelliJ_IDEA_Icon.svg/960px-IntelliJ_IDEA_Icon.svg.png",
        title: "IntelliJ",
        tag: "platform"
    },

    {
        icon: "https://i.ibb.co/61nck0S/download-removebg-preview.png",
        title: "VS Code",
        tag: "platform"
    },
    {
        icon: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        title: "Postman",
        tag: "platform"
    },
    {
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Windows_logo_-_2012.png/960px-Windows_logo_-_2012.png",
        title: "Windows",
        tag: "platform"
    },
    {
        icon: "https://i.pinimg.com/originals/77/f0/33/77f033d90e28c29dc6ce7006e66d0caa.png",
        title: "Mac",
        tag: "platform"
    },

    {
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/UbuntuCoF.svg/1280px-UbuntuCoF.svg.png",
        title: "Ubuntu",
        tag: "platform"
    },

]

export const projects = [
    {
        id: 0,
        title: 'MM-Calendar',
        type: 'Book & Reference',
        image: 'MMCalendarApp.png',
        description: 'A calendar app that can calculate and convert to the date between Myanmar and English. Users can add notes, events, and memories to the note features.',
        techStack: ['Kotlin', 'MVVM', 'LiveData', 'Room', 'Coroutine', 'Hilt', 'Nav Graph', 'Firebase', 'ironSource'],
        liveDemo: 'https://play.google.com/store/apps/details?id=com.nanhm.mmcalendar',
        category: 'personal',
    },
    {
        id: 1,
        title: 'MMENG Dictionary',
        type: 'Book & Reference',
        image: 'MMENGDictionaryApp.png',
        description: "A dictionary app that allow user to search the translation of each Burmese word into English. It's useful for those who learn English vs Burmese Language.",
        techStack: ['Kotlin', 'MVVM', 'Room', 'Google Speech Recognition', 'Firebase SDK', 'ironSource SDK'],
        liveDemo: 'https://play.google.com/store/apps/details?id=com.hms.myanmar_englishdictionarytranslator',
        category: 'personal',
    },
    {
        id: 2,
        title: "MMThetpone",
        type: "Book & Reference",
        image: "MMThetponeApp.png",
        description: "A Spelling App for those who learning Myanmar Word. It can be searched and checked the Myanmar over 200 provided words.",
        techStack: ['Kotlin', 'MVVM', 'Room', 'Coroutine', 'Hilt', 'Firebase', 'ironSource Monetization'],
        liveDemo: "https://play.google.com/store/apps/details?id=com.ottsolution.myanmarthatpone",
        category: 'personal',
    },
    {
        id: 3,
        title: 'Dhamma',
        type: 'Tool',
        image: 'DhammaApp.png',
        description: 'An app serves the user to study Buddha Dhamma Script and listen to audio from Buddhist Monks, ABIDHAMA Teachers, Meditation Trainers with over 10,000 resources.',
        techStack: ['Kotlin', 'MVVM', 'Room', 'Coroutine', 'Hilt', 'Nav Graph', 'ExoPlayer', 'Firebase', 'ironSource'],
        liveDemo: 'https://play.google.com/store/apps/details?id=com.haymarsan.dhammapiya',
        category: 'personal',
    },
    {
        id: 4,
        title: "ENGMMDictionary",
        type: "Book & Reference",
        image: "ENGMMDictionaryApp.png",
        description: "An offline dictionary allows users to search for the explanation of each English word in the Myanmar language with over 30,000 words.",
        techStack: ['Kotlin', 'MVVM', 'Room', 'Coroutine', 'Hilt', 'Speech Recognition', 'Firebase', 'ironSource'],
        liveDemo: "https://play.google.com/store/apps/details?id=com.peteaung.engmmdictionary",
        category: 'personal',
    },
    {
        id: 5,
        title: "MyHealth",
        type: "Book & Referene",
        image: "MyHealthApp.png",
        description: "The app provides the following features: health information and knowledge, BMI Calculator, Due Date Calculator, and full descriptions of each result.",
        techStack: ['Kotlin', 'MVVM', 'Room', 'Coroutine', 'Hilt', 'Navigation', 'Retrofit', 'Firebase', 'ironSource'],
        liveDemo: "https://play.google.com/store/apps/details?id=com.peteaung.myhealth",
        category: 'personal',
    },
    {
        id: 6,
        title: "My Profile",
        type: "Web App",
        image: "Portfolio.png",
        description: "My Profile is a website for my Cloud Computing Course project. It's developed by using React tech and deploy on AWS",
        techStack: ["HTML", "CSS", "JavaScript, React", "AWS"],
        github: "https://github.com/ksmaprince/KHUN-AUNG-PORTFOLIO",
        liveDemo: "",
        category: 'academic',
    },
    {
        id: 7,
        title: "Restaurant Management",
        type: "Android & iOS",
        image: "RESTAURANT.png",
        description: "A hybrid mobile platform application development aims to displaying food and writing notes in restaurant using React Native, Restful API combine with Material Design using Paper library to be100% installable on both Android and iOS platform.",
        techStack: ["React Native", "JavaScript"],
        github: "https://github.com/ksmaprince/Restaurant-Management-App",
        category: 'academic',
    },
    {
        id: 9,
        title: "SmartHR",
        type: "HR App",
        image: "KBZ-Bank.jpg",
        description: "Mobile App for KBZ Bank internal employees. All the features are related to HR such as Attendance, CheckIn/CheckOut by Geolocation, Leave/OT, Learning and Training, HR Announcement, Payslip, etc.",
        techStack: ["Kotlin", "Android Studio", "MVI", "RxJava", "Retrofit", "KOIN", "Clean Architecture", "Jetpack Libraries", "Git", "Bitbucket", "Jira"],
        category: 'work',
    },
    {
        id: 11,
        title: "KBZConnect",
        type: "Banking App",
        image: "KBZConnect.png",
        description: "Mobile App that allows the bank customer to search the nearby branches and ATM locations and currency exchange rates.",
        techStack: ["Kotlin", "Android Studio", "MVP", "RxJava", "Retrofit", "Git", "Bitbucket", "Jira"],
        liveDemo: "https://play.google.com/store/apps/details?id=com.kbzbank.kbzconnect&hl=en_US&gl=US",
        category: 'work',
    }, {
        id: 14,
        title: "KBZ Catalyst",
        type: "HR App",
        image: "KBZ-Bank.jpg",
        description: "Mobile App for KBZ Bank internal employees. It collects the employees' KYC data including Biometric data such as face capturing, voice recording, etc.",
        techStack: ["Kotlin", "Android Studio", "MVP", "RxJava", "Retrofit", "Git", "Bitbucket", "Jira"],
        category: 'work',
    },
    {
        id: 10,
        title: "Digital Onboarding",
        type: "Banking App",
        image: "KBZ-Bank.jpg",
        description: "Android Application for KBZ Bank internal use to onboard the customer to the bank. The main feature is bank account opening function by using mobile device portably.",
        techStack: ["Kotlin", "Android Studio", "MVI", "RxJava", "Retrofit", "KOIN", "Clean Architecture", "Jetpack Libraries", "Git", "Bitbucket", "Jira"],
        category: 'work',
    }, {
        id: 12,
        title: "KBZ mBanking",
        type: "Mobile Banking",
        image: "KBZMobileBanking.png",
        description: "A banking app that allows the user to view account balances & transactions, transfer money, and pay bills from the mobile device,",
        techStack: ["Java", "Android Studio", "MVP", "RxJava", "Retrofit", "Clean Architecture", "Git", "Bitbucket", "Jira"],
        liveDemo: "https://play.google.com/store/apps/details?id=com.ofss.fcdb.mobile.android.phone.kbz.launcher&hl=en_US&gl=US",
        category: 'work',
    }, {
        id: 13,
        title: "KBZ Pay",
        type: "eWallet",
        image: "KBZPay.png",
        description: "A mobile wallet app along with banking functions that is simple and convenient to transact money in Myanmar. I was responsible for deploying the app to the Play Store, Xiaomi, Huawei, and the internal app server.",
        techStack: ["Java", "Web App"],
        liveDemo: "https://play.google.com/store/apps/details?id=com.kbzbank.kpaycustomer&hl=en_US&gl=US",
        category: 'work',
    }, {
        id: 15,
        title: "Movie Vault",
        type: "Android App",
        image: "MovieVault.png",
        description: "An android app using Jetpack Compose for intuitive design and good user experience. This app serves as entertainment with the user interface to register, log in, browse movie collections over 1000 titles, watch movie trailers, and save their favorites.",
        techStack: ["Kotlin", "Android Studio", "MVVM", "Coroutine", "Retrofit", "Dagger-Hilt", "Jetpack Libraries"],
        github: "https://github.com/ksmaprince/MovieValut?tab=readme-ov-file",
        category: 'academic',
    }, {
        id: 16,
        title: "Movie Vault System",
        type: "Backend App",
        image: "MovieVaultAPI.png",
        description: "Backend Web Service to provide REST API for mobile development project by following the coding best practices and deploying on Azure as server-side to ensure 99.0% uptime on and global accessibility. ",
        techStack: ["Java", "Spring Boot", "Spring Data JPA", "JWT", "Hibernate", "MySQL"],
        github: "https://github.com/ksmaprince/MovieValut-REST-WebService",
        category: 'academic',
    },
    {
        id: 17,
        title: "Product Management System ",
        type: "Wee App",
        image: "PRODUCTMNG.png",
        description: "A Web application project to manage product stock using React JS as frontend and Express, NodeJS as backend and integrate with Open AI for chat response at least 90% user queries.",
        techStack: ["React", "JavaScript", "Material UI"],
        github: "https://github.com/ksmaprince/Product-Management-System",
        category: 'academic',
    }


]